<template>
    <div class="ah-accounting-date-picker query-date-input-set">
        <el-date-picker
            v-model="startDate"
            type="date"
            prefix-icon="-"
            style="width: 180px;"
            value-format="timestamp"
            format="yyyy年M月d日"
            :picker-options="{ shortcuts: startDatePickerOptions.shortcuts, disabledDate }"
            :clearable="false"
        />
        <span>至</span>
        <el-date-picker
            v-model="endDate"
            type="date"
            prefix-icon="-"
            style="width: 180px;"
            value-format="timestamp"
            format="yyyy年M月d日"
            ref="endDatePicker"
            :picker-options="{ disabledDate }"
            :clearable="false"
        />
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        openDate: {
            type: Number,
            default: null,
        },
    },
    computed: {
        startDate: {
            set(val) {
                const TIME = Number(
                    moment(val)
                        .startOf('day')
                        .format('x'),
                );
                this.$nextTick(() => {
                    this.$emit('input', [TIME, this.value[1]]);
                    this.onStartDateChange(val);
                });
            },
            get() {
                return this.value[0];
            },
        },
        endDate: {
            set(val) {
                const TIME = Number(
                    moment(val)
                        .endOf('day')
                        .format('x'),
                );
                this.$nextTick(() => {
                    this.$emit('input', [this.value[0], TIME]);
                });
            },
            get() {
                return this.value[1];
            },
        },
        startDatePickerOptions() {
            const vm = this;
            return {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                            vm.$emit('input', [
                                vm.value[0],
                                Number(
                                    moment()
                                        .endOf('day')
                                        .format('x'),
                                ),
                            ]);
                        },
                    },
                    {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                            vm.$emit('input', [
                                vm.value[0],
                                Number(
                                    moment()
                                        .subtract(1, 'day')
                                        .endOf('day')
                                        .format('x'),
                                ),
                            ]);
                        },
                    },
                    {
                        text: '本週',
                        onClick(picker) {
                            picker.$emit(
                                'pick',
                                Number(
                                    moment()
                                        .startOf('week')
                                        .format('x'),
                                ),
                            );
                            vm.$emit('input', [
                                vm.value[0],
                                Number(
                                    Number(
                                        moment()
                                            .endOf('week')
                                            .format('x'),
                                    ),
                                ),
                            ]);
                        },
                    },
                    {
                        text: '上週',
                        onClick(picker) {
                            picker.$emit(
                                'pick',
                                Number(
                                    moment()
                                        .subtract(1, 'week')
                                        .startOf('week')
                                        .format('x'),
                                ),
                            );
                            vm.$emit('input', [
                                vm.value[0],
                                Number(
                                    Number(
                                        moment()
                                            .subtract(1, 'week')
                                            .endOf('week')
                                            .format('x'),
                                    ),
                                ),
                            ]);
                        },
                    },
                    {
                        text: '本月',
                        onClick(picker) {
                            picker.$emit(
                                'pick',
                                Number(
                                    moment()
                                        .startOf('month')
                                        .format('x'),
                                ),
                            );
                            vm.$emit('input', [
                                vm.value[0],
                                Number(
                                    moment()
                                        .endOf('month')
                                        .format('x'),
                                ),
                            ]);
                        },
                    },
                    {
                        text: '上個月',
                        onClick(picker) {
                            picker.$emit(
                                'pick',
                                Number(
                                    moment()
                                        .subtract(1, 'month')
                                        .startOf('month')
                                        .format('x'),
                                ),
                            );
                            vm.$emit('input', [
                                vm.value[0],
                                Number(
                                    moment()
                                        .subtract(1, 'month')
                                        .endOf('month')
                                        .format('x'),
                                ),
                            ]);
                        },
                    },
                    {
                        text: '今年',
                        onClick(picker) {
                            picker.$emit(
                                'pick',
                                Number(
                                    moment()
                                        .startOf('year')
                                        .format('x'),
                                ),
                            );
                            vm.$emit('input', [
                                vm.value[0],
                                Number(
                                    moment()
                                        .endOf('year')
                                        .format('x'),
                                ),
                            ]);
                        },
                    },
                    {
                        text: '去年',
                        onClick(picker) {
                            picker.$emit(
                                'pick',
                                Number(
                                    moment()
                                        .subtract(1, 'year')
                                        .startOf('year')
                                        .format('x'),
                                ),
                            );
                            vm.$emit('input', [
                                vm.value[0],
                                Number(
                                    moment()
                                        .subtract(1, 'year')
                                        .endOf('year')
                                        .format('x'),
                                ),
                            ]);
                        },
                    },
                ],
            };
        },
    },
    methods: {
        disabledDate(date) {
            if (!this.openDate) return false;

            const DATE = moment(date);
            const FIRST_DATE_OF_THIS_YEAR = moment(+this.openDate).startOf('year');

            return DATE.isBefore(moment(this.openDate)) && DATE.isAfter(FIRST_DATE_OF_THIS_YEAR.subtract(1, 'day').endOf('day'));
        },
        onStartDateChange(startDate) {
            this.endDate = Number(moment(Number(this.endDate)).format('x'));
            this.endDate = Number(
                moment(Number(this.endDate))
                    .set('year', moment(startDate).year())
                    .format('x'),
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.ah-accounting-date-picker.query-date-input-set {
    display: flex;
    gap: 5px;
    align-items: center;
    color: #606266;
    font-size: 10pt;

    .el-input__inner {
        text-align: center;
    }
}
</style>
